import { IStaffBusinessSettings } from 'experiments/StaffLink/StaffLink.types'
import { IAbExp, IAbExperiment } from './experiment.types'

export const getFormattedAbProfile = (data: any): IAbExp => {
  return {
    billingInSecondaryUnit: data?.profile?.features?.billing_in_secondary_unit || false,
    collectionListOfInvoicesV1: data?.profile?.features?.collection_list_of_invoices_v1 || false,
    clQuickSummary: data?.profile?.features?.quick_summary || false,
    clViewV2: data?.profile?.features?.cl_view_v2 || false,
    collectionListSummaryV2: data?.profile?.features?.collection_list_summary_v2 || false,
    dynamicStatements: data?.profile?.features?.dynamic_statements || false,
    allowAppControls: data?.profile?.features?.allow_app_controls || false,
    tallyConnect: data?.profile?.features?.tally_connect || false,
    busyConnect: data?.profile?.features?.busy_connect || false,
    paidSoonBanner: data?.profile?.features?.paid_soon_banner || false,
    billingWeb: data?.profile?.features?.billing_web || false,
    okTermLoanAppBlock: data?.profile?.features?.oktermloan_app_block || false,
    staffLink: data?.profile?.features?.staff_link || false,
    editBillTransactionWeb: data?.profile?.features?.edit_bill_transaction_web || false,
    cashDeposit: data?.profile?.features?.cash_deposit || false,
    argoTrading: data?.profile?.features?.argo_trading || false,
    onDemandDistribution: data?.profile?.features?.on_demand_distribution || false,
    returnItemsV1: data?.profile?.features?.return_items_v1 || false,
    downtime: data?.profile?.features?.downtime || false,
    okDebitOrderManagement: data?.profile?.features?.okdebit_order_management || false,
    previewUpload: data?.profile?.features?.preview_upload || false,
    settleCollections: data?.profile?.features?.settle_collections || false,
    okDebitLiveSalesV1: data?.profile?.features?.okdebit_staff_invoice_v1 || false,
    downloadSummaryAllowCustomColumnName:
      data?.profile?.features?.download_summary_allow_custom_column_names || false,
    downloadSummaryPaymentModeInRowFormat:
      data?.profile?.features?.download_summary_payment_mode_in_row_format || false,
    okdAutoReminder: data?.profile?.features?.okd_auto_reminder || false,
    bulkWhatsappCampaignFs: data?.profile?.features?.bulk_whatsapp_campaign_fs || false,
    itemUnitSelectionLocalCache: data?.profile?.features?.item_unit_selection_local_cache || false,
    isMixpanelWhitelisting: data?.profile?.features?.mixpanel_whitelisting || false,
    businessManagers: data?.profile?.features?.business_managers || false
  }
}

export const getFormattedAbExperiment = (data: any): IAbExperiment => {
  return {
    'activation_web-all-paid_soon_banner':
      data?.profile?.experiments['activation_web-all-paid_soon_banner'] || {}
  }
}

export const getFormattedBusinessSettings = (data: any): IStaffBusinessSettings => {
  return {
    loading: false,
    bill: {
      canStaffEditRate: data.bill?.can_staff_edit_rate || false
    },
    order: {
      restrictStaffLowInv: data.order?.restrict_staff_low_inv || false,
      enable_staff_manual_discount: data.order?.enable_staff_manual_discount || false
    },
    offer: {
      apply_multiple: data.offer?.apply_multiple || false
    },
    ready: true
  }
}
